import { LocationDto, Role, RoleEnum } from "@braoshzmvavz/picnube-common";
import React from "react";
import ReactCountryFlag from "react-country-flag";
import { HiChevronLeft, HiMap, HiPencil, HiTrash } from "react-icons/hi";
import LocationRelatedContent from "./LocationRelatedContent";
import { openDeleteModal } from "../modal/confirm";
import { RootState } from "src/app/store";
import { useSelector } from "react-redux";

export default function LocationDetail(props: {
  location: LocationDto;
  style: any;
  closeLocationDetailView: () => void;
  onDeleteLocation: (location: LocationDto) => void;
}) {
  const hasWritePermission = useSelector((state: RootState) =>
    [
      RoleEnum.WRITE.toString(),
      RoleEnum.OWNER.toString(),
      RoleEnum.ADMIN.toString(),
    ].includes(state.profile.currentSpace.role)
  );

  const deleteLocation = async (location: LocationDto) => {
    if (!hasWritePermission) return;

    openDeleteModal(
      false,
      `Delete location '${location.name}'`,
      "Are you sure you want to delete this location?",
      `This action is irreversible and cannot be undone. All content linked to '${location.name}' will be affected.`,
      "Delete location",
      () => {
        props.onDeleteLocation(location);
        props.closeLocationDetailView();
      }
    );
  };

  const LocationDetailActions = () => {
    if (!hasWritePermission) return null;
    return (
      <div className="flex flex-row gap-2">
        <div className="flex items-center gap-1 p-2 hover:bg-grey-800 cursor-pointer rounded-lg w-fit">
          <HiPencil />
        </div>
        <div
          className="flex items-center gap-1 p-2 hover:bg-grey-800 cursor-pointer rounded-lg w-fit"
          onClick={() => deleteLocation(props.location)}
        >
          <HiTrash />
        </div>
      </div>
    );
  };

  if (!props.location) return null;
  return (
    <div
      className="flex flex-col w-full h-full p-4 sm:p-8"
      style={{ ...props.style }}
    >
      <div className="flex items-center justify-between mb-4">
        <div
          className="flex items-center gap-1 p-2 hover:bg-grey-800 cursor-pointer rounded-lg w-fit"
          onClick={props.closeLocationDetailView}
        >
          <HiChevronLeft />
          <HiMap />
        </div>
        <LocationDetailActions />
      </div>

      <div className="flex flex-col">
        <h1 className="text-lg">{props.location.name}</h1>
        <div className="text-sm text-grey-600 flex flex-row gap-2 items-center mt-1">
          <ReactCountryFlag
            style={{ fontFamily: "Twemoji Country Flags" }}
            countryCode={props.location.countryCode}
          ></ReactCountryFlag>
          <div>
            {props.location.region}, {props.location.country}
          </div>
        </div>
      </div>

      <div className="flex flex-col mt-8 h-full w-full">
        <LocationRelatedContent location={props.location} />
      </div>
    </div>
  );
}
